<template>
  <div>
    <div class="p-grid">
      <div class="p-col">
        <label>Delegate</label>
        <multiselect v-model="delegate" id="delegate" label="name" track-by="id" placeholder="Type to search" open-direction="bottom" :options="delegates" :multiple="false" :searchable="true" :loading="delegatesLoading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" :limit="1" :max-height="300" :show-no-results="false" :hide-selected="false" :show-labels="false" @search-change="searchDelegates" @select="delegateSelected">
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title">{{ props.option.realPerson ? `${props.option.getName()} (${props.option.associationName})` : props.option.associationName }}</span>
            </div>
          </template>
          <template slot="noOptions">
            Start typing to see delegates
          </template>
        </multiselect>
      </div>
      <div class="p-col">
        <label>Motion</label>
        <multiselect v-model="motion" id="motion" label="name" track-by="id" placeholder="Type to search" open-direction="bottom" :options="motions" :multiple="false" :searchable="true" :clear-on-select="false" :close-on-select="true" :limit="1" :max-height="300" :show-no-results="false" :hide-selected="false" :show-labels="false">
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title">{{ props.option.name }}</span>
            </div>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="p-d-flex p-ai-center">
      <div class="p-pr-3">
        <SelectButton v-model="opinion" :options="opinionOptions" optionLabel="label" optionValue="code" />
      </div>
      <div class="p-pr-3" v-show="showGenderSelect">
        <SelectButton v-model="gender" :options="genderOptions" optionLabel="label" optionValue="code" />
      </div>
      <div>
        <button class="pure-button" :disabled="!isValid" @click="submit">Submit Card</button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import SelectButton from 'primevue/selectbutton'
export default {
  name: 'CardForm',
  components: {
    Multiselect,
    SelectButton
  },
  data () {
    return {
      delegate: null,
      motion: null,
      opinion: null,
      gender: null,
      delegates: this.$store.getters['delegates/all'],
      delegatesLoading: false,
      submitting: false
    }
  },
  computed: {
    motions () {
      return this.$store.getters['motions/all']
    },
    opinionOptions () {
      return [
        {
          code: 'For',
          label: 'For'
        },
        {
          code: 'Against',
          label: 'Against'
        }
      ]
    },
    genderOptions () {
      return [
        {
          code: 'W',
          label: 'Woman'
        },
        {
          code: 'NW',
          label: 'Non-woman'
        }
      ]
    },
    isValid () {
      return this.delegate !== null && this.motion !== null && this.gender !== null && this.opinion !== null
    },
    showGenderSelect () {
      if (!this.delegate) {
        return false
      }
      return this.delegate.gender === null || this.delegate.gender === undefined
    }
  },
  methods: {
    searchDelegates (query) {
      this.delegatesLoading = true
      this.delegates = this.$store.getters['delegates/search'](query)
      this.delegatesLoading = false
    },
    clearAll () {
      this.selectedCountries = []
    },
    delegateSelected (delegate) {
      console.log('selected')
      console.log(delegate)
      if (delegate.gender !== null && delegate.gender !== undefined) {
        this.gender = delegate.gender
      } else {
        this.gender = null
      }
    },
    async submit () {
      if (!this.isValid) {
        return false
      }
      this.submitting = true
      let payload = {
        /**
        motion_id: this.motion.id,
        delegate_id: this.delegate.id,
        **/
        mid: this.motion.id,
        did: this.delegate.id,
        opinion: this.opinion
      }
      if (this.delegate.gender === null || this.delegate.gender === undefined) {
        payload.gender = this.gender
        this.$store.commit('delegates/UPDATE', Object.assign(
          {},
          this.delegate,
          {
            gender: this.gender
          }
        ))
      }
      console.log(payload)
      await this.$store.dispatch('cards/create', payload)
      this.submitting = false
      this.clear(true)
    },
    clear (clearMotion = false) {
      this.delegate = null
      this.opinion = null
      this.gender = null
      if (clearMotion) {
        this.motion = null
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/CardForm.vue